/**
 * T&D — Wikilinks parser for La Sala.
 * Extracts pensamiento IDs from [[ ]] wikilinks in HTML content.
 */

/**
 * Extract pensamiento IDs referenced in wikilinks from HTML content.
 * Each wikilink is a <span class="wikilink" data-pensamiento-id="...">.
 * @param {string} contenidoHtml
 * @returns {string[]} Array of pensamiento UUIDs
 */
export function parsearWikilinks(contenidoHtml) {
  if (!contenidoHtml) return [];
  const parser = new DOMParser();
  const doc = parser.parseFromString(contenidoHtml, 'text/html');
  const spans = doc.querySelectorAll('span.wikilink[data-pensamiento-id]');
  return Array.from(spans).map(s => s.dataset.pensamientoId);
}

/**
 * Extract raw wikilink titles from plain text or HTML.
 * Catches [[Title]] written by hand (not via dropdown).
 * @param {string} contenido - HTML or plain text
 * @returns {string[]} Array of titles referenced in [[ ]]
 */
export function parsearWikilinksTitulos(contenido) {
  if (!contenido) return [];
  const text = contenido.replace(/<[^>]*>/g, '');
  const matches = [...text.matchAll(/\[\[([^\]]+)\]\]/g)];
  return matches.map(m => m[1].trim()).filter(Boolean);
}

// ============================================
// FASE 2: Detección automática de afinidad
// ============================================
// Requiere: pgvector extension + OPENAI_API_KEY para embeddings
// Se activará cuando haya 50+ pensamientos en La Sala
//
// export async function detectarAfinidad(pensamientoId, contenido) {
//   // 1. Generar embedding via OpenAI text-embedding-3-small
//   // 2. Guardar en pensamientos.embedding (VECTOR(1536))
//   // 3. Buscar similares via match_pensamientos RPC
//   // 4. Crear sinapsis tipo 'afinidad' para matches > 0.78
// }
